import {downloadFile} from '@domain/file-download'
import {ApiClient as Api} from '@hconnect/apiclient'
import {useMutation, type UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import moment from 'moment-timezone'

type UseExportJobsToBeDoneParams = {
  plantUpmId: string
  plantCode: string
  plantName: string
}

type UseExportJobsToBeDoneOptions = UseMutationOptions<void, AxiosError, any>

export const useExportJobsToBeDone = (
  {plantUpmId, plantCode, plantName}: UseExportJobsToBeDoneParams,
  options?: UseExportJobsToBeDoneOptions
) => {
  const {onError, ...restOptions} = options ?? {}
  return useMutation<void, AxiosError, {associatedRole?: string}>({
    mutationFn: async ({associatedRole}) => {
      const {data} = await Api.axiosInstance.get<Blob>(
        `/jobs-to-be-done/api/${plantUpmId}/jobs-to-be-done/export`,
        {
          params: associatedRole ? {associatedRole} : undefined,
          responseType: 'blob'
        }
      )

      const formattedTime = moment().format('YYYY-MM-DDTHH-mm-ss')
      const fileName = `JTBD_${plantName}_${plantCode}_${formattedTime}.xlsx`

      downloadFile(new Blob([data]), fileName)
    },
    onError: (error, variables, context, mutation) => {
      onError?.(error, variables, context, mutation)
    },
    ...restOptions
  })
}
